import styled from "styled-components";

export const CustomPageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const SectionWrapper = styled.div`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

export const SectionImage = styled.img`
  width: 100%;
  max-height: 420px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 24px;
  display: block;
`;

export const SectionTitle = styled.h2`
  font-weight: 600;
  color: var(--neutral);
  font-size: 2rem;
  width: 100%;
  margin: 0 0 40px 0;
  position: relative;
  display: inline-block;
  letter-spacing: -0.5px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: -12px;
    width: 48px;
    height: 3px;
    background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 32px;

    &::before {
      width: 40px;
      height: 2px;
      bottom: -10px;
    }
  }
`;
